<div class="dialog-background" style="z-index: 1000">
  <div class="add-media-asset-dialog dialog-content">
    <div class="title-bar">
      @if (!assetToUpdate && !createBrand) {
        <span
          class="pull-left"
          i18n="Title bar for adding new media asset"
          >Add your media asset</span
          >
        }
        @if (!assetToUpdate && createBrand) {
          <span
            class="pull-left"
            i18n="Title bar for creating new brand"
            >Create a new brand</span
            >
          }
          @if (assetToUpdate && assetToUpdate.asset_type !== 'brand') {
            <span
              class="pull-left"
              i18n="Title bar for updating media asset content"
              >Update your media asset</span
              >
            }
            @if (assetToUpdate && assetToUpdate.asset_type === 'brand') {
              <span
                class="pull-left"
                i18n="Title bar for updating brand asset content"
                >Update your brand</span
                >
              }
              <i class="fa fa-times close-icon" (click)="close()"></i>
            </div>

            <div class="dialog-body">
              @if (assetTypes.length > 1) {
                <label i18n="Media asset type">Asset Type</label>
                <select
                  id="asset-type"
                  class="form-control light"
                  [(ngModel)]="selectedAssetType"
                  (change)="onAssetTypeChanged()"
                  [attr.disabled]="selectionPreview || uploadComplete ? '' : null"
                  >
                  @if (assetTypes.indexOf('brand') >= 0) {
                    <option
                      i18n="Brand media asset type"
                      value="brand"
                      >
            Brand
          </option>
                  }
                  @if (assetTypes.indexOf('banner') >= 0) {
                    <option
                      i18n="Image media asset type"
                      value="banner"
                      >
            Banner
          </option>
                  }
                  @if (assetTypes.indexOf('image') >= 0) {
                    <option
                      i18n="Image media asset type"
                      value="image"
                      >
            Image
          </option>
                  }
                  @if (assetTypes.indexOf('image') >= 0) {
                    <option
                      i18n="Video media asset type"
                      value="video"
                      >
            Video
          </option>
                  }
                </select>
              }

              <div class="turn-video-selection-on-container">
                @if (
                  selectedAssetType === 'video' &&
                  canSelect &&
                  !selectionOn &&
                  !selectionPreview
                  ) {
                  <button
                    class="btn btn-primary"
                    (click)="turnOnSelection()"
                    id="turn-video-selection-on-btn"
                    >
                    <span i18n="Button label for selecting a local file asset"
                      >Select Asset</span
                      >
                      <span class="icon icon-right">
                        <i class="fa fa-file-image-o" aria-hidden="true"></i>
                      </span>
                    </button>
                  }
                </div>

                @if (selectedAssetType === 'video' && !videoPreviewOn) {
                  <div>
                    <p
                      class="youtube-instructions"
                      i18n="Instructions for you tube video instructions"
                      >
          Accepting URLs from YouTube, Vimeo, Wistia, Optimum, Brightcove and Synthesia.
        </p>
                    <div
          [ngClass]="{
            'has-error':
              !mediaAssetGroup.controls['video_url'].valid &&
              mediaAssetGroup.controls['video_url'].touched
          }"
                      >
                      <input
                        id="videoUrlInput"
                        class="form-control"
                        [formControl]="mediaAssetGroup.controls['video_url']"
                        (focus)="onVideoUrlFocus()"
                        (blur)="onVideoUrlBlur()"
                        placeholder="Video URL"
                        i18n-placeholder="Video URL placeholder text"
                        spellcheck="false"
                        />
                      <app-error-display [control]="mediaAssetGroup.controls['video_url']"></app-error-display>
                    </div>
                  </div>
                }

                @if (!imagePreviewOn && !selectionOn && selectedAssetType !== 'video') {
                  <div
                    class="upload-drag-drop-area"
                    (drop)="dropFile($event)"
                    (dragover)="dragOver($event)"
                    >
                    <p>Drag your asset here</p>
                    <p>or</p>
                    <div>
                      @if (!canSelect) {
                        <input
                          type="file"
                          id="fileUploadInput"
                          (change)="selectLocalFile($event)"
                          style="display: none"
                          [attr.accept]="acceptAttribute"
                          />
                        <label
                          id="fileUploadInput"
                          class="btn btn-primary"
                          for="fileUploadInput"
                          >
                          <span i18n="Button label for selecting a local file asset"
                            >Select Asset</span
                            >
                            <span class="icon icon-right">
                              <i class="fa fa-file-image-o" aria-hidden="true"></i>
                            </span>
                          </label>
                        } @else {
                          <label
                            id="fileUploadInput"
                            class="btn btn-primary"
                            (click)="turnOnSelection()"
                            >
                            <span i18n="Button label for selecting a local file asset"
                              >Select Asset</span
                              >
                              <span class="icon icon-right">
                                <i class="fa fa-file-image-o" aria-hidden="true"></i>
                              </span>
                            </label>
                          }
                        </div>
                      </div>
                    <p class="requirements-hint" id="requirementsHint">{{ requirementsHint }}</p>
                    }

                    @if (selectionOn) {
                      <div>
                        <div class="browse-btn-container">
                          <input
                            type="file"
                            id="fileUploadInput"
                            (change)="selectLocalFile($event)"
                            style="display: none"
                            [attr.accept]="acceptAttribute"
                            />
                          @if (
                            selectedAssetType === 'image' ||
                            selectedAssetType === 'brand' ||
                            selectedAssetType === 'banner'
                            ) {
                            <label
                              id="fileUploadInput"
                              class="btn btn-primary"
                              for="fileUploadInput"
                              >
                              <span i18n="Button label for selecting a local file asset"
                                >Browse</span
                                >
                                <span class="icon icon-right">
                                  <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                </span>
                              </label>
                            }
                          </div>
                          <div class="search-container">
                            <input
                              id="search-field"
                              class="search-field"
                              type="search"
                              placeholder="Search"
                              i18n-placeholder="Placeholder for search input"
                              [(ngModel)]="searchText"
                              (keypress)="checkForEnter($event)"
                              />
                            <button
                              id="submit-search"
                              class="btn btn-primary submit-search"
                              (click)="submitSearchRequest()"
                              >
                              <i class="fa fa-search"></i>
                            </button>
                            @if (searchCriteria) {
                              <i
                                id="clear-search"
                                class="fa fa-times-circle"
                                aria-hidden="true"
                                (click)="clearSearch()"
                              ></i>
                            }
                          </div>
                          <div
                            class="selector-area"
                            debounce
                            data-infinite-scroll
                            infiniteScroll
                            [infiniteScrollContainer]="mediaScrollArea"
                            [infiniteScrollDistance]="scrollDistance"
                            [infiniteScrollThrottle]="throttle"
                            (scrolled)="onScrollDown()"
                            >
                            @for (selectableAsset of selectableMediaAssets; track selectableAsset) {
                              <div
                                id="selectable-asset-{{ selectableAsset.asset_id }}"
                                class="selectable-asset"
              [class.selected]="
                selectedAsset &&
                selectedAsset.asset_id === selectableAsset.asset_id
              "
                                (click)="selectExistingAsset(selectableAsset)"
                                >
                                @if (
                                  selectableAsset.asset_type === 'image' ||
                                  selectableAsset.asset_type === 'brand' ||
                                  selectableAsset.asset_type === 'banner'
                                  ) {
                                  <img
                                    src="{{ selectableAsset.s3_url }}"
                                    />
                                }
                                @if (selectableAsset.asset_type === 'video') {
                                  <img
                                    [src]="selectableAsset.videoThumbnailUrl"
                                    />
                                }
                              </div>
                            }
                          </div>
                          @if (selectableMediaAssets.length == 0) {
                            <div
                              class="not-found"
          i18n="
            Message that the user gets when there are no media assets to select
            from
          "
                              >
          There were no media assets found.
        </div>
                          }
                        </div>
                      }

                      @if (selectedAssetType !== 'video') {
                        <div
                          class="image-preview"
                          [class.active]="imagePreviewOn"
                          >
                          <img id="previewImage" [src]="previewImage ? previewImage : ''" />
                          @if (imagePreviewOn && !uploadStarted) {
                            <i
                              id="removeAssetBtn"
                              class="fa fa-times-circle remove-asset-icon"
                              aria-hidden="true"
                              title="Remove"
                              i18n-title="Tooltip for the button that removes the currently loaded/uploaded asset"
                              (click)="resetState()"
                            ></i>
                          }
                        </div>
                      }

                      @if (selectedAssetType === 'video' && videoPreviewOn) {
                        <div
                          class="video"
                          [class.active]="videoPreviewOn"
                          >
                          <app-video [videoUrl]="currentVideoUrl" [showUrl]="true"></app-video>
                        </div>
                      }

                      <upload
                        [fileNamePrefix]="'Asset file name: '"
                        (uploadComplete)="saveComplete($event)"
                        (uploadAborted)="saveAborted()"
                        (uploadError)="handleUploadError($event)"
                        >
                      </upload>

                      @if (!uploadStarted) {
                        <div
          [ngClass]="{
            'has-error':
              !mediaAssetGroup.controls['short_name'].valid &&
              mediaAssetGroup.controls['short_name'].touched
          }"
                          >
                          <label class="form-label" i18n="Asset display name"
                            >Display Name</label
                            >
                            <input
                              id="displayName"
                              class="form-control"
                              type="text"
                              [formControl]="mediaAssetGroup.controls['short_name']"
                              [attr.readonly]="selectedAsset"
                              />
                            <app-error-display [control]="mediaAssetGroup.controls['short_name']"></app-error-display>
                          </div>
                          @if (
                            selectedAssetType === 'image' || selectedAssetType === 'banner'
                            ) {
                            <div
          [ngClass]="{
            'has-error':
              !mediaAssetGroup.controls['alternate_text'].valid &&
              mediaAssetGroup.controls['alternate_text'].touched
          }"
                              >
                              <label class="form-label">Alternate Text</label>
                              <input
                                id="altText"
                                class="form-control"
                                type="text"
                                [(ngModel)]="altText"
                                [formControl]="mediaAssetGroup.controls['alternate_text']"
                                [attr.readonly]="selectedAsset"
                                />
                              <app-error-display [control]="mediaAssetGroup.controls['alternate_text']"></app-error-display>
                            </div>
                          }
                          <label class="form-label">Asset ID</label
                            >@if (!assetToUpdate) {
                            <span> (optional)</span>
                          }
                          <rn-form-input-state-control
                            [formReference]="mediaAssetGroup.controls['user_asset_id']"
                            >
                            <input
                              id="create-asset-id"
                              type="text"
                              class="form-control"
                              [formControl]="mediaAssetGroup.controls['user_asset_id']"
                              />
                          </rn-form-input-state-control>
                          @if (createBrand) {
                            <div
          [ngClass]="{
            'has-error':
              !mediaAssetGroup.controls['branding_color'].valid &&
              mediaAssetGroup.controls['branding_color'].touched
          }"
                              >
                              <label class="form-label" i18n="Brand Color">Brand Color</label>
                              <br />
                              <color-picker
                                [(color)]="brandingColor"
                                (colorChanged)="setColor($event)"
                              ></color-picker>
                              <app-error-display [control]="mediaAssetGroup.controls['branding_color']"></app-error-display>
                            </div>
                          }
                        }

                        @if (uploadComplete) {
                          <div class="upload-success-banner" id="uploadSuccessMessage">
                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                            <span i18n="Message shown once a media asset has been successfully uploaded">Asset uploaded successfully</span>
                          </div>
                          @if (selectedAssetType !== 'video' && loadedFile) {
                            <div class="uploaded-asset-info" id="uploadedAssetInfo">
                              <div class="uploaded-asset-name">{{ uploadedFileName }}</div>
                              <div class="uploaded-asset-meta">
                                <span>{{ uploadedFileTypeLabel }}</span>
                                <span>{{ uploadedImageDimensions }}</span>
                                <span>{{ uploadedFileSizeLabel }}</span>
                              </div>
                            </div>
                          }
                          @if (selectedAssetType === 'video') {
                            <div class="uploaded-asset-info" id="uploadedAssetInfo">
                              <div class="uploaded-asset-name">{{ displayName }}</div>
                              <div class="uploaded-asset-meta">
                                <span>{{ currentVideoUrl }}</span>
                              </div>
                            </div>
                          }
                        }

                        <div class="footer-bar">
                          <div class="pull-left">
                            @if (!uploadComplete) {
                              <div class="cancel-link" (click)="close()">
                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                                <span i18n="Link to cancel test launch">Cancel</span>
                              </div>
                            }
                          </div>
                          <div class="pull-right">
                            @if (
                              (selectedAssetType !== 'video' &&
                              loadedFile &&
                              loadedImageValid &&
                              !uploadStarted) ||
                              (selectionPreview && !selectedAsset) ||
                              (selectedAssetType === 'video' &&
                              videoPreviewOn &&
                              !selectedAsset &&
                              !uploadComplete)
                              ) {
                              <button
                                id="saveBtn"
                                class="btn btn-primary"
                                (click)="save()"
                                [class.inactive]="!isValid"
                                [disabled]="!isValid"
                                >
                              <span i18n="Button heading to add a new media asset">Save</span>
                            </button>
                          }
                          @if (
                            selectedAssetType === 'video' && !videoPreviewOn && !selectedAsset
                            ) {
                            <button
                              id="nextBtn"
                              class="btn btn-primary"
                              (click)="nextStepForVideo()"
                              [class.inactive]="!isValid"
                              [disabled]="!isValid"
                              >
                              <span
              i18n="
                Button heading go to next step in the process of adding video
              "
                                >Next</span
                                >
                              </button>
                            }
                            @if (selectedAsset && !selectionPreview) {
                              <button
                                id="selectBtn"
                                class="btn btn-primary"
                                (click)="previewSelection()"
                                [class.inactive]="!isValid"
                                [disabled]="!isValid"
                                >
                                <span i18n="Button heading to select an existing asset"
                                  >Select</span
                                  >
                                </button>
                              }
                              @if (selectedAsset && selectionPreview) {
                                <button
                                  id="confirmBtn"
                                  class="btn btn-primary"
                                  (click)="confirmSelection()"
                                  [class.inactive]="!isValid"
                                  [disabled]="!isValid"
                                  >
                                  <span i18n="Button heading to confirm selected asset">Confirm</span>
                                </button>
                              }
                              @if (loadedFile && !loadedImageValid) {
                                <button
                                  id="okBtn"
                                  class="btn btn-primary"
                                  (click)="resetState()"
                                  >
                                  <span
              i18n="
                retry button to for dialog for adding media asset if an error
                happened
              "
                                    >Retry</span
                                    >
                                  </button>
                                }
                                @if (uploadComplete) {
                                  <button
                                    id="retryBtn"
                                    class="btn btn-primary"
                                    (click)="close()"
                                    >
                                    <span i18n="OK button to close dialog for adding media asset"
                                      >OK</span
                                      >
                                    </button>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <message-dialog></message-dialog>
